/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Tilføj din egen emoji',
  'fabric.emoji.add.label': 'Tilføj emoji',
  'fabric.emoji.cancel.label': 'Annullér',
  'fabric.emoji.categories.label': 'Vælg en emoji-kategori',
  'fabric.emoji.categories.search.results': 'Søgeresultater',
  'fabric.emoji.category.activity': 'Aktivitet',
  'fabric.emoji.category.all.uploads': 'Alle uploads',
  'fabric.emoji.category.flags': 'Flag',
  'fabric.emoji.category.foods': 'Mad og drikke',
  'fabric.emoji.category.frequent': 'Ofte benyttede',
  'fabric.emoji.category.nature': 'Natur',
  'fabric.emoji.category.objects': 'Objekter',
  'fabric.emoji.category.people': 'Personer',
  'fabric.emoji.category.places': 'Rejser og steder',
  'fabric.emoji.category.productivity': 'Atlassian og produktivitet',
  'fabric.emoji.category.symbols': 'Symboler',
  'fabric.emoji.category.user.uploads': 'Dine uploads',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Vælg en fil til emojien. JPG, PNG eller GIF. Maks. størrelse: 1 MB',
  'fabric.emoji.choose.file.title': 'Vælg fil',
  'fabric.emoji.delete.description': 'Alle eksisterende forekomster af denne emoji erstattes med  {emojiShortName}',
  'fabric.emoji.delete.label': 'Fjern',
  'fabric.emoji.delete.screenreader.tooltip': "Tryk på Tilbage for at slette {shortName}-emoji'en",
  'fabric.emoji.delete.title': 'Fjern emoji',
  'fabric.emoji.delete.tooltip': 'Slet',
  'fabric.emoji.emojipicker.emoi.roledescription': 'emojiknap',
  'fabric.emoji.emojipicker.error': 'Fejl!',
  'fabric.emoji.error.delete.failed': 'Fjern mislykkede',
  'fabric.emoji.error.image.too.big': 'Det valgte billede er større end 1 MB',
  'fabric.emoji.error.invalid.image': 'Det valgte billede er ugyldigt',
  'fabric.emoji.error.upload.failed': 'Upload mislykkedes',
  'fabric.emoji.error.upload.timeout': 'Upload fik timeout',
  'fabric.emoji.image.requirements': 'JPG, PNG eller GIF. Maks. størrelse 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Angiv et navn til den nye emoji',
  'fabric.emoji.picker': 'Emojivælger',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Søgeresultater} other {Emojis}}',
  'fabric.emoji.pickerlist.tabpanel': 'Emoji-handlinger og listepanel',
  'fabric.emoji.placeholder': 'fx hej',
  'fabric.emoji.preview': 'Din nye emoji {emoji} ser flot ud',
  'fabric.emoji.preview.title': 'Vis',
  'fabric.emoji.retry.label': 'Prøv igen',
  'fabric.emoji.search.label': 'Emojinavn',
  'fabric.emoji.search.placeholder': 'Søg',
  'fabric.emoji.search.status': 'Viser alle emojis',
  'fabric.emoji.search.status.count': 'Fandt {count} emojis',
  'fabric.emoji.select.skin.list.ariaLabel': 'Hudfarvevælger',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Vælg din hudfarve, {selectedTone} valgt',
};
